module.exports = __webpack_public_path__ + "img/sun-thur-cal.c5b5d5b6.svg";